import React from "react";
import "../stylesheets/coverImage.css"

export function CoverImage({ imageUrl}) {
  return (
    <img className="coverImage" src={imageUrl} alt="coverImage" />
  );
};